'use client'

import PropTypes from 'prop-types'
import { Pill } from '@repo/ui/Pill'

const getMatterStatus = (matter) => {
  if (matter.dateArchived) return 'Archived'
  if (matter.dateCompleted) return 'Completed'
  return 'Open'
}

const getMatterBackgroundColor = (matter) => {
  if (matter.dateArchived) return 'background.mid'
  if (matter.dateCompleted) return 'success.main'
  return 'secondary.main'
}

export const MatterStatusPill = ({ matter }) => {
  return (
    <Pill
      label={getMatterStatus(matter)}
      color={matter.dateArchived ? 'black' : 'white'}
      backgroundColor={getMatterBackgroundColor(matter)}
    />
  )
}

MatterStatusPill.propTypes = {
  matter: PropTypes.object
}
